const defaultState = [];

export default (state = defaultState, action) => {
  switch (action.type) {
    case 'SET_ORG_DOMAINS':
      return action.orgDomains;
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/store/reducers/orgDomains.js